import Vue from "vue";
import store from "../store/store";
import Router from "vue-router";
import common from "../utils/common/common";
Vue.use(Router);

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push (location) {
  return originalPush.call(this,location).catch(err => err)
}
Router.prototype.replace = function replace(location){
  return originalReplace.call(this , location).catch(err=>err)
}

//判断是否为移动端
const IsMobile = function () {
  let info = navigator.userAgent;
  let agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "iPad"];
  for(let i = 0; i < agents.length; i++){
    if(info.indexOf(agents[i]) >= 0) return true;
  }
  return false;
}
const loadModeDrive = function (view) {
  return IsMobile() ? view.wap() : view.pc()
}
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "defalut",
      component: () => import("../views/main-frame/main-frame.vue")
    },
    // 小鹏对账单
    {
      path:"/xiaopengBill",
      name:"xiaopengBill",
      redirect:{
        name:"billManage"
      },
      component:() => import("@/views/xiaopengBill/index.vue"),
      children:[
        {
          path:"billManage",
          name:"billManage",
          component:() => import("@/views/xiaopengBill/billManage.vue"),
        },
        {
          path:"billDetail",
          name:"billDetail",
          component:() => import("@/views/xiaopengBill/billDetail.vue"),
        },
      ]
    },
    // 分销商企业管理系统-企业管理-留资
    {
      path: "/enterpiseManage",
      name: "enterpiseManage",
      meta:{
        title: "企业管理"
      },
      component: () => import("../views/distributor-EnterpiseManage/index.vue"),
      children:[
        {
          path:"capital-retention",
          name:"capital-retention",
          meta:{
            title: "企业留资"
          },
          component: () => import("../views/distributor-EnterpiseManage/capital-retention.vue")
        },
        {
          path:"cooperation-enterpise",
          name:"cooperation-enterpise",
          meta:{
            title: "合作企业"
          },
          component: () => import("../views/distributor-EnterpiseManage/cooperation-enterpise.vue")
        },
        {
          path:"compile-cooperationEnterpise",
          name:"compile-cooperationEnterpise",
          meta:{
            title: "编辑合作企业"
          },
          component: () => import("../views/distributor-EnterpiseManage/compile-cooperationEnterpise.vue")
        },
        {
          path:"order-enterprise",
          name:"order-enterprise",
          meta:{
            title: "订单列表"
          },
          component: () => import("../views/distributor-EnterpiseManage/order-enterprise.vue")
        },
        {
          path:"billing-management",
          name:"billing-management",
          meta:{
            title: "对账单列表"
          },
          component: () => import("../views/distributor-EnterpiseManage/billing-management.vue")
        },
        {
          path:"billing-manage-create",
          name:"billing-manage-create",
          meta:{
            title: "新建对账单"
          },
          component: () => import("../views/distributor-EnterpiseManage/billing-manage-create.vue")
        },
        // TODO 企业审批
        {
          path: "enterpriseApproval",
          name: "enterpriseApproval",
          meta: {
            title: "企业审批"
          },
          component: () => import("@/views/distributor-EnterpiseManage/enterpriseApproval.vue")
        },
      ]
    },
    //使用帮助
    {
      path:"/useHelp",
      name:"useHelp",
      component:() => import("../views/useHelp/index.vue")
    },
    //车源资产看板--start--xixi
    {
      path: "/carSourcePanel",
      name: "carSourcePanel",
      component: () => import("../views/carSourcePanel/index.vue"),
      children: [
        {
          //交通违法看板
          path: "trafficPanel",
          name: "trafficPanel",
          meta: { title: "交通违法看板" },
          component: () =>
            import("../views/carSourcePanel/trafficPanel")
        },
        {
          //交通违法看板详情
          path: "panelDetails",
          name: "panelDetails",
          meta: { title: "看板详情" },
          component: () =>
            import("../views/carSourcePanel/trafficPanel/panelDetails")
        },
        {
          //看板首页
          path: "panelPage",
          name: "panelPage",
          component: () =>
            import("../views/carSourcePanel/panelPage/panelPage.vue")
        },
        {
          //长时间下架列表页面
          path: "offline",
          name: "offline",
          component: () =>
            import("../views/carSourcePanel/panelPage/offline.vue")
        },
        {
          //长时间列表页面
          path: "longTimePage",
          name: "longTimePage",
          component: () =>
            import("../views/carSourcePanel/longTimePage/longTimePage.vue")
        },
        {
          //任务列表
          path: "taskList",
          name: "taskList",
          component: () =>
            import("../views/carSourcePanel/taskList/taskList.vue")
        },
        {
          //我的任务
          path: "myTask",
          name: "myTask",
          component: () =>
            import("../views/carSourcePanel/taskList/taskList.vue")
        },
        {
          //任务详情
          path: "taskDetail",
          name: "taskDetail",
          meta: { title: "任务详情" },
          component: () =>
            import("../views/carSourcePanel/taskList/taskDetail.vue")
        },
      ]
    },
    //车源看板---end
    //门店系统start
    {
      path: "/storeSystem",
      name: "storeSystem",
      component: () => import("@/views/storeSystem/index.vue"),
      children: [
        {
          path: "setPrice",
          name: "setPrice",
          component: () => import("@/views/storeSystem/setPrice/setPrice.vue")
        },
        {
          path: "setPriceDetail",
          name: "setPriceDetail",
          component: () =>
            import("@/views/storeSystem/setPrice/setPriceDetail.vue")
        },
        {
          path: "order",
          name: "order",
          component: () => import("@/views/storeSystem/order/index.vue")
        },
        {
          path: "orderDetail",
          name: "orderDetail",
          component: () => import("@/views/storeSystem/order/orderDetail.vue")
        },
        {
          path: "store",
          name: "store",
          component: () => import("@/views/storeSystem/store/index.vue")
        },
        {
          path: "storeDetail",
          name: "storeDetail",
          component: () => import("@/views/storeSystem/store/storeDetail.vue")
        },
        {
          path: "inventory",
          name: "inventory",
          component: () => import("@/views/storeSystem/inventory/index.vue")
        },
        {
          path: "inventory-manage",
          name: "inventoryManage",
          component: () => import("@/views/storeSystem/inventory/manage.vue")
        },
        {
          path: "car-manage",
          name: "carManage",
          component: () => import("@/views/storeSystem/carManage.vue")
        }
      ]
    },
    //门店系统end
    {
      path: "/gofun",
      name: "MainFramePage",
      component: () => import("../views/main-frame/main-frame.vue")
    },
    {
      path: "/home",
      name: "HomePage",
      component: () => import("../views/home/home.vue")
    },
    {
      path: "/login",
      name: "LoginPage",
      component: () => import("../views/login/login.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/findPass",
      name: "findPass",
      component: () => import("../views/login/findPass.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/findPassNext",
      name: "findPassNext",
      component: () => import("../views/login/findPassNext.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/modifyInitPass",
      name: "modifyInitPass",
      component: () => import("../views/login/modifyInitPass.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/internalMessage",
      name: "internalMessage",
      component: () => import("../views/message/innerMessage.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/platformMessage",
      name: "platformMessage",
      component: () => import("../views/message/platformMessage.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/updateMessage",
      name: "updateMessage",
      component: () => import("../views/message/updateMessage.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/myColleague",
      name: "myColleague",
      component: () => import("../views/home/myColleague.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/messageKind",
      name: "messageKind",
      component: () => import("../views/message/messageKind.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/addMessage",
      name: "addMessage",
      component: () => import("../views/message/addMessage.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/messageDetail/:id",
      name: "messageDetail",
      component: () => import("../views/message/messageDetail.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/carSetting",
      name: "carSetting",
      component: () => import("../views/car/carSetting.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/mine",
      name: "mine",
      component: () => import("../views/mine/index.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/log",
      name: "log",
      component: () => import("../views/log/log.vue"),
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/partsSupplier",
      name: "partsSupplier",
      component: () => import("../views/partsSupplier/index.vue"),
      children: [
        {
          path: "purchaseOrder",
          name: "purchaseOrder",
          component: () => import("../views/partsSupplier/purchaseOrder.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        },
        {
          path: "purchaseOrderDetail/:id",
          name: "purchaseOrderDetail",
          component: () =>
            import("../views/partsSupplier/purchaseOrderDetail.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        },
        {
          path: "billList",
          name: "billList",
          component: () => import("../views/partsSupplier/billList.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        },
        {
          path: "billDetail/:depotId",
          name: "billDetail",
          component: () => import("../views/partsSupplier/billDetail.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        }
      ],
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/stationMap",
      component: () => import("../views/stationMap/index.vue")
    },
    {
      path: "/contract",
      name: "contract",
      component: () => import("../views/contract/index.vue"),
      children: [
        {
          path: "myContract",
          name: "myContract",
          component: () => import("../views/contract/myContract.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        },
        {
          path: "userContract",
          name: "userContract",
          component: () => import("../views/contract/userContract.vue"),
          meta: {
            requireLoginAuth: false,
            keepAlive: false
          }
        }
      ],
      meta: {
        requireLoginAuth: false,
        keepAlive: false
      }
    },
    {
      path: "/financial",
      name: "financial",
      component: () => import("../views/financial/index.vue"),
      children: [
        {
          path: "order-recoveryDeduction", // 订单追损
          name: "order-recoveryDeduction",
          component: () => import("../views/financial/order-recoveryDeduction.vue")
        },
        {
          path: "outlets/:parkingType", // 网点 实体：1，虚拟：2
          name: "outlets",
          component: () => import("../views/financial/entityOutlets.vue")
        },
        {
          path: "reverseTrusteeship", // 反向托管
          name: "reverseTrusteeship",
          component: () => import("../views/financial/reverseTrusteeship.vue")
        },
        {
          path: "balanceAmount/:grantType", // 余额  1 实体 2 虚拟
          name: "balanceAmount",
          component: () => import("../views/financial/balanceAmount.vue")
        },
        {
          path: "orderReport", // 订单明细
          name: "orderReport",
          component: () => import("../views/financial/orderReport_now.vue")
        },
        {
          path: "orderReportAgo",
          name: "orderReportAgo",
          component: () => import("../views/financial/orderReport_ago.vue")
        },
        {
          path: "pushCost", //推费明细
          name: "pushCost",
          component: () => import("../views/financial/pushCost.vue")
        },
        {
          path: "traffic", //交通违法
          name: "traffic",
          component: () => import("../views/financial/traffic.vue")
        },
        {
          path: "energy",
          name: "energy",
          component: () => import("../views/financial/energy.vue")
        },
        {
          path: "parkingRate",
          name: "parkingRate",
          component: () => import("../views/financial/parkingRate.vue")
        },
        {
          path: "c2cBussiness",
          name: "c2cBussiness",
          component: () => import("../views/financial/c2cBussiness.vue")
        },
        {
          path: "coupons",
          name: "coupons",
          component: () => import("../views/financial/coupons.vue")
        },
        {
          path: "RentalOutlets", //整租网点
          name: "RentalOutlets",
          component: () => import("../views/financial/RentalOutlets.vue")
        },
        {
          path: "operations",
          name: "operations",
          component: () => import("../views/financial/operations.vue")
        },
        {
          path: "travelCard",
          name: "travelCard",
          component: () => import("../views/financial/travelCard.vue")
        },
        {
          path: "home",
          name: "home",
          component: () => import("../views/financial/home.vue")
        }
      ]
    },
    {
      path: "/trajectory", // 辅助选址
      name: "trajectory",
      meta: { logId: 10, logName: "辅助选址", requireAuth: true },
      component: () => import("../views/GIS/Trajectory.vue")
    },

    // 财务-日对账
    {
      path: "/financeHome", // 首页
      name: "financeHome",
      meta:{
        title:"日对账首页"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/home"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      })
    },
    // 财务日对账二期
    {
      path: "/new_financeHome", // 新首页
      name: "newFinanceHome",
      meta:{
        title:"新日对账首页"
      },
      component: () => import("@/views/newFinancial/pc/newHome"),
    },
    {
      path: "/finance/operatingIncome/minuteHour", // 短租收入-分时租金收入
      name: "finance-operatingIncome_minuteHour",
      meta:{
        title:"分时租金收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/minuteHour"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/operatingIncome/dayRent", // 日租租金收入
      name: "finance-operatingIncome_dayRent",
      meta:{
        title:"日租租金收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/dayRent"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/insurance", //- 短租保险
      name: "finance-insurance",
      meta:{
        title:"短租保险收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/insurance"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/platformPush", //- 短租推送收入
      name: "finance-platformPush",
      meta:{
        title:"短租推送收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/platformPush"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/operatingIncome/coupon", // 卡券
      name: "finance-operatingIncome_coupon",
      meta:{
        title:"卡券收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/coupon"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/wholeRent", //- 长租租金
      name: "finance-wholeRent",
      meta:{
        title:"长租租金收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/wholeRent"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    {
      path: "/finance/longInsurance", //- 长租保险
      name: "finance-longInsurance",
      meta:{
        title:"长租保险收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/longInsurance"),
        // wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    // longPlatformPush
    {
      path: "/finance/longPlatformPush", //- 长租推送收入
      name: "finance-longPlatformPush",
      meta:{
        title:"长租推送收入"
      },
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/longPlatformPush"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
    },
    // 重庆-公务用车
    {
      path: "/enterpriceG",
      name: "enterpriceG",
      meta: {
        title: "企业管理"
      },
      component: () => import("@/views/chongqingyongche/enterprice/index.vue"),
    },
    {
      path: "/employeeG",
      name: "employeeG",
      meta: {
        title: "人员管理"
      },
      component: () => import("@/views/chongqingyongche/employee/index.vue"),
    },
    {
      path: "/stationG",
      name: "stationG",
      meta: {
        title: "场站管理"
      },
      component: () => import("@/views/chongqingyongche/station/index.vue"),
    },
    {
      path: "/stationG/edit",
      name: "stationG",
      meta: {
        title: "场站管理"
      },
      component: () => import("@/views/chongqingyongche/station/edit.vue"),
    },
    {
      path: "/vehicleG",
      name: "vehicleG",
      meta: {
        title: "车辆管理"
      },
      component: () => import("@/views/chongqingyongche/vehicle/index.vue"),
    },
    {
      path: "/vehicleG/terminal",
      name: "vehicleG",
      meta: {
        title: "车辆管理"
      },
      component: () => import("@/views/chongqingyongche/vehicle/terminal.vue"),
    },
    {
      path: "/billingG",
      name: "billingG",
      meta: {
        title: "计费管理"
      },
      component: () => import("@/views/chongqingyongche/billing/index.vue"),
    },
    {
      path: "/billingG/edit",
      name: "billingG",
      meta: {
        title: "计费管理"
      },
      component: () => import("@/views/chongqingyongche/billing/edit.vue"),
    },
    {
      path: "/billG",
      name: "billG",
      meta: {
        title: "账单管理"
      },
      component: () => import("@/views/chongqingyongche/bill/index.vue"),
    },
    {
      path: "/billG/edit",
      name: "billG",
      meta: {
        title: "账单管理"
      },
      component: () => import("@/views/chongqingyongche/bill/edit.vue"),
    },
    {
      path: "/billG/track",
      name: "billG",
      meta: {
        title: "用车轨迹"
      },
      component: () => import("@/views/chongqingyongche/bill/track.vue"),
    },
    {
      path: "/ordersG",
      name: "ordersG",
      meta: {
        title: "订单管理"
      },
      component: () => import("@/views/chongqingyongche/orders/index.vue"),
    },
    {
      path: "/ordersG/edit",
      name: "ordersG",
      meta: {
        title: "订单管理"
      },
      component: () => import("@/views/chongqingyongche/orders/edit.vue"),
    },
    {
      path: "/finance/fictitious", //- 虚拟收入抵减
      name: "finance-fictitious",
      component: () => loadModeDrive({
        pc: () => import("@/views/newFinancial/pc/fictitious"),
        wap: () => import("@/views/newFinancial/wap/premium"),
      }),
      meta: {
        noOrderId:true,
        title:"虚拟收入抵减"
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let path = to.path;
  let token = common.getCookie("token");
  let menuList = store.state.menuList || [];
  let btnList = store.state.btnList || [];
  let whiteList = ["/login", "/findPass", "/findPassNext", "/modifyInitPass","/billG/track"];
  let V = whiteList.includes(path);
  if (!token && !V && process.env.API_ENV !== "serve") {
    //

    router.replace({ path: "/login" });
    window.parent.postMessage({ msg: "exit" });
  }
  if (!V) {
    if (!btnList.length) {
      await store.dispatch("getBtnList");
    }
    if (!menuList.length) {
      await store.dispatch("getMenuList");
      await store.dispatch("getFirstAppList");
      next();
    }
  }
  if (!menuList.includes(path)) {
    // throw Error("该页面无权限");
    // if (to.path !== "/login") {
    //   router.replace({ path: "/gofun" })
    // } else {
    next();
    // }
  } else {
    next();
  }
  document.title = "GoFun全链接商家平台";
});

export default router;



// WEBPACK FOOTER //
// ./src/router/routers.js